module.exports = __webpack_public_path__ + "static/assets/e04d8c93cf14ec09031b47d619c04f74.svg";